"use client";

// App-level route boundary. Catches render errors in any route segment (server
// or client) that weren't contained by a closer FeatureBoundary or segment
// `error.tsx`. The root layout shell stays mounted; `reset()` re-renders the
// segment without a full page reload.

import { useEffect } from "react";
import { ErrorPage } from "@/components/tailwind/ErrorPage";
import { reportError } from "@/lib/observability";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, { scope: "app-error", digest: error.digest });
  }, [error]);

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-4">
      <ErrorPage
        title="Something went wrong"
        message="An unexpected error occurred while loading this page. You can try again."
        errorId={error.digest}
        showRetry
        onRetry={reset}
      />
    </div>
  );
}
